import { Link } from 'react-router-dom';
import SRTCirculo from '../../img/SRTCirculo.webp';

const Srt = () => {
   return (
      <>
            {/* <div className="bg-latitud animated fadeIn" >
                <div className="container section">
                    <div className="row">
                        <div className="center-vertical">
                            <div className="col s12 m12 l6 x6 center">
                                <Link href="https://www.argentina.gob.ar/srt"  target="_blank"><img src={SRTCirculo} className="responsive-img"/></Link>
                            </div>
                            <div className="col s12  m12 l6  x6 center text-white">
                                <strong style={{"font-size":"25px"}}>¿Cómo actuar en caso de accidente?</strong><br/><br/>
                                <strong style={{"font-size":"20px"}}>Atención de Denuncias</strong><br/>
                                <span style={{"font-size":"18px"}}>0800 199 0022</span><br/><br/>
                                <strong style={{"font-size":"20px"}}>Guardia</strong><br/>
                                <span style={{"font-size":"18px"}}>0388 156 867 840</span>/<br/><br/>
                                <Link to={"accidente"} className="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Ver más
                                    <i className="material-icons right">send</i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
         <div className="section animated fadeIn" style={{ margin: '0px 0', padding: 0 }}>
            {/* BANNER INSTITUCIONAL DE ACCIDENTES - ANCHO COMPLETO */}
            <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', padding: '50px 5%', backgroundColor: '#039be5', margin: 0 }}>
               <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0, maxWidth: '1400px', marginLeft: 'auto', marginRight: 'auto' }}>
                  {/* IMAGEN / LOGO SRT CON CONTENEDOR CIRCULAR */}
                  <div className="col s12 m12 l5 x5 center-align" style={{ marginBottom: '25px' }}>
                        <div style={{ display: 'inline-block', padding: '12px', background: 'rgba(255, 255, 255, 0.15)', borderRadius: '50%', boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}>
                        <Link to="https://www.argentina.gob.ar/srt" target="_blank" rel="noopener noreferrer">
                           <img 
                              src={SRTCirculo} 
                              alt="Superintendencia de Riesgos del Trabajo - SRT" 
                              className="circle responsive-img" 
                              style={{ width: '240px', height: '240px', objectFit: 'cover', border: '4px solid #ffffff', display: 'block' }} 
                           />
                        </Link>
                        </div>
                  </div>
                  {/* INFORMACIÓN DE CONTACTO Y BOTÓN */}
                  <div className="col s12 m12 l7 x7 white-text center-on-small-only" style={{ paddingLeft: '20px' }}>
                        <h4 style={{ fontWeight: '700', fontSize: '2rem', margin: '0 0 15px 0', letterSpacing: '0.5px' }}>
                        ¿Cómo actuar en caso de accidente?
                        </h4>
                        
                        <div style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                        <div style={{ marginBottom: '10px' }}>
                           <span style={{ fontSize: '0.9rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: '0.9', display: 'block' }}>
                              Atención de Denuncias
                           </span>
                           <span style={{ fontSize: '1.35rem', fontWeight: '700', letterSpacing: '0.5px' }}>
                              0800 199 0022
                           </span>
                        </div>

                        <div>
                           <span style={{ fontSize: '0.9rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: '0.9', display: 'block' }}>
                              Guardia
                           </span>
                           <span style={{ fontSize: '1.25rem', fontWeight: '700', letterSpacing: '0.5px' }}>
                              0388 156 867 840
                           </span>
                        </div>
                        </div>

                        <Link 
                        to={"accidente"} 
                        className="btn waves-effect waves-light white grey-text text-darken-3 z-depth-1 hoverable" 
                        style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 32px', height: '46px', lineHeight: '46px' }}
                        >
                        Ver más información
                        <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>arrow_forward</i>
                        </Link>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Srt